import { PropsOf } from 'types';
import connect from './connect';
import LegacyEditCaptionsModal from './LegacyEditCaptionsModal';

export default connect(LegacyEditCaptionsModal);
export type LegacyEditCaptionsModalProps = PropsOf<ReturnType<typeof connect>>;
